import * as React from 'react';
export const truemoneySvg = React.forwardRef(function truemoneySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M28.794 9.55h-6.881c-.45 0-.85.284-.997.708l-1.079 3.096-.035.102-.025.07-2.967 8.51c-.057.175-.122.374-.201.578a1.728 1.728 0 0 1-.27.46.952.952 0 0 1-.15.146l-.01.009a.856.856 0 0 1-.25.134h-.001l-.007.003-.004.001a.91.91 0 0 1-.236.046h8.271a.638.638 0 0 0 .159-.02c.201-.051.631-.238.812-.902l4.297-12.343a.45.45 0 0 0-.426-.598Z',
      fill: '#FF7B00',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm8.43 21.07.006-.015.015-.045.026-.073.035-.1.043-.124.052-.148.06-.17.067-.19.074-.21.08-.228.085-.244.09-.258.096-.271.099-.283.103-.293.106-.302.108-.308.11-.315.112-.319.113-.321.113-.323.114-.322.112-.32.111-.318.11-.312.107-.306.105-.299.102-.289.097-.279.094-.266.088-.252.084-.238.077-.22.071-.203.064-.183c.02-.053.038-.107.057-.161l.049-.139.04-.115c.022-.062.041-.126.07-.185l.003-.003.001-.001v-.002l.002-.001c.006-.011.008-.021.015-.032.057-.125.207-.26.268-.28l-.932-3.131A.95.95 0 0 0 10.036 8H3.463a.462.462 0 0 0-.444.594l3.7 12.436c.153.441.485.67.824.687h.001c.353.016.713-.2.886-.647Z',
      fill: '#FF000F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm11.865 11.805-.003.002.003-.002Zm2.566 9.86-.046-.155-.023-.08-1.586-5.327-1.11-3.725a.526.526 0 0 1 .082-.47l.007-.008a.468.468 0 0 1 .094-.086l.012-.008.003-.002a.67.67 0 0 0-.268.28.627.627 0 0 0-.018.033l-.002.006c-.03.06-.05.123-.07.185l-.041.115-.049.139-.057.162-.064.182-.07.203a117.075 117.075 0 0 0-.162.458l-.088.252-.093.266-.098.279-.102.29-.104.298-.108.306-.11.312-.11.318-.113.32-.113.322-.114.323-.112.321-.112.319-.11.315-.11.308c-.034.101-.07.201-.105.302l-.103.293-.1.283c-.03.09-.063.18-.094.271l-.091.258-.085.244-.08.227-.074.21-.067.19-.06.17-.051.149-.044.124-.035.1-.025.073-.016.045-.006.015c-.173.448-.533.663-.886.648a.334.334 0 0 1-.02 0h6.923a5.477 5.477 0 0 1-.016-.053Z',
      fill: '#AA0017',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.838 13.354c-.06-.214-.118-.428-.175-.642a1.877 1.877 0 0 0-.196-.504 1.04 1.04 0 0 0-.378-.375.905.905 0 0 0-.138-.062 1.012 1.012 0 0 0-.28-.046h-6.517a.534.534 0 0 0-.29.08l-.002.001-.012.008a.462.462 0 0 0-.095.086l-.006.009a.525.525 0 0 0-.081.47l1.108 3.725 1.586 5.327.08.267.3 1.05c.02.055.18.488.62.625a.923.923 0 0 0 .555-.006l.005-.001c.003 0 .005-.002.008-.003.004 0 .007-.002.01-.003a.844.844 0 0 0 .24-.131 1.044 1.044 0 0 0 .16-.155 1.73 1.73 0 0 0 .27-.46c.078-.204.144-.403.2-.577.032-.096.06-.184.087-.262l.205-.587.258-.738.297-.85.322-.923.334-.957.333-.951.317-.908a2689.782 2689.782 0 0 1 .532-1.526l.189-.54.094-.269.024-.07.036-.102Z',
      fill: '#FFCD00',
    }),
  );
});
truemoneySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var truemoney = {
  category: 'brand',
  colorable: false,
  name: 'truemoney',
  svg: truemoneySvg,
};
